// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AssistanceGetAssistanceOptionsData,
  AssistanceGetAssistanceOptionsResponses,
  AssistanceSendAssistanceData,
  AssistanceSendAssistanceErrors,
  AssistanceSendAssistanceResponses,
  CampaignsGetActiveCampaignsAsyncData,
  CampaignsGetActiveCampaignsAsyncErrors,
  CampaignsGetActiveCampaignsAsyncResponses,
  CampaignsReserveCampaignAsyncData,
  CampaignsReserveCampaignAsyncErrors,
  CampaignsReserveCampaignAsyncResponses,
  CustomerCreateCustomerProfileV2AsyncData,
  CustomerCreateCustomerProfileV2AsyncErrors,
  CustomerCreateCustomerProfileV2AsyncResponses,
  DeviationControllerGetAllData,
  DeviationControllerGetAllResponses,
  HistoryGetDetailsData,
  HistoryGetDetailsErrors,
  HistoryGetDetailsResponses,
  HistoryGetTransactionHistoryData,
  HistoryGetTransactionHistoryErrors,
  HistoryGetTransactionHistoryOrderData,
  HistoryGetTransactionHistoryOrderErrors,
  HistoryGetTransactionHistoryOrderResponses,
  HistoryGetTransactionHistoryResponses,
  JourneyGetData,
  JourneyGetEarlierDeparturesData,
  JourneyGetEarlierDeparturesErrors,
  JourneyGetEarlierDeparturesForLegData,
  JourneyGetEarlierDeparturesForLegErrors,
  JourneyGetEarlierDeparturesForLegResponses,
  JourneyGetEarlierDeparturesResponses,
  JourneyGetErrors,
  JourneyGetJourneyPlanData,
  JourneyGetJourneyPlanErrors,
  JourneyGetJourneyPlanResponses,
  JourneyGetLaterDeparturesData,
  JourneyGetLaterDeparturesErrors,
  JourneyGetLaterDeparturesForLegData,
  JourneyGetLaterDeparturesForLegErrors,
  JourneyGetLaterDeparturesForLegResponses,
  JourneyGetLaterDeparturesResponses,
  JourneyGetResponses,
  JourneyReplaceLegData,
  JourneyReplaceLegErrors,
  JourneyReplaceLegInJourneyData,
  JourneyReplaceLegInJourneyErrors,
  JourneyReplaceLegInJourneyResponses,
  JourneyReplaceLegResponses,
  LocationGetGoAheadLocationsData,
  LocationGetGoAheadLocationsResponses,
  OfferGetPeriodTicketOffersData,
  OfferGetPeriodTicketOffersErrors,
  OfferGetPeriodTicketOffersResponses,
  OfferGetTripPatternInfoData,
  OfferGetTripPatternInfoErrors,
  OfferGetTripPatternInfoResponses,
  TicketRefundTicketData,
  TicketRefundTicketErrors,
  TicketRefundTicketResponses,
  TicketReserveData,
  TicketReserveErrors,
  TicketReserveResponses,
  TicketReviewOrderData,
  TicketReviewOrderErrors,
  TicketReviewOrderResponses,
  TicketSendSmsData,
  TicketSendSmsErrors,
  TicketSendSmsResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get options for assistance.
 *
 * Returns assistance options to be used by clients.
 */
export const assistanceGetAssistanceOptions = <ThrowOnError extends boolean = false>(
  options?: Options<AssistanceGetAssistanceOptionsData, ThrowOnError>,
): RequestResult<AssistanceGetAssistanceOptionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AssistanceGetAssistanceOptionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Assistance/options',
    ...options,
  });

/**
 * Send assistace for customer to Bane Nord
 *
 * Returns assistance booking for the order.
 */
export const assistanceSendAssistance = <ThrowOnError extends boolean = false>(
  options?: Options<AssistanceSendAssistanceData, ThrowOnError>,
): RequestResult<AssistanceSendAssistanceResponses, AssistanceSendAssistanceErrors, ThrowOnError> =>
  (options?.client ?? client).post<AssistanceSendAssistanceResponses, AssistanceSendAssistanceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Assistance/send',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Get active campaigns from sanity
 */
export const campaignsGetActiveCampaignsAsync = <ThrowOnError extends boolean = false>(
  options?: Options<CampaignsGetActiveCampaignsAsyncData, ThrowOnError>,
): RequestResult<CampaignsGetActiveCampaignsAsyncResponses, CampaignsGetActiveCampaignsAsyncErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    CampaignsGetActiveCampaignsAsyncResponses,
    CampaignsGetActiveCampaignsAsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Campaigns/active',
    ...options,
  });

/**
 * Reserves a campaign on given date
 */
export const campaignsReserveCampaignAsync = <ThrowOnError extends boolean = false>(
  options: Options<CampaignsReserveCampaignAsyncData, ThrowOnError>,
): RequestResult<CampaignsReserveCampaignAsyncResponses, CampaignsReserveCampaignAsyncErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CampaignsReserveCampaignAsyncResponses,
    CampaignsReserveCampaignAsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Campaigns/reserve',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Create customer profile
 */
export const customerCreateCustomerProfileV2Async = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerCreateCustomerProfileV2AsyncData, ThrowOnError>,
): RequestResult<
  CustomerCreateCustomerProfileV2AsyncResponses,
  CustomerCreateCustomerProfileV2AsyncErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CustomerCreateCustomerProfileV2AsyncResponses,
    CustomerCreateCustomerProfileV2AsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Customer/create',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const deviationControllerGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<DeviationControllerGetAllData, ThrowOnError>,
): RequestResult<DeviationControllerGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DeviationControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/deviation',
    ...options,
  });

/**
 * Retrieve the order history for a customer.
 *
 * Returns a list of orders customer has made. To do a detailed search of a specific order
 * save OrderId and ServiceJourneyRef and send into details/{orderId}/{serviceJourneyRef}.
 * To map passengers from details/ api, save the OrderLineId as it represents each leg trip for a specific passenger.
 */
export const historyGetTransactionHistory = <ThrowOnError extends boolean = false>(
  options?: Options<HistoryGetTransactionHistoryData, ThrowOnError>,
): RequestResult<HistoryGetTransactionHistoryResponses, HistoryGetTransactionHistoryErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    HistoryGetTransactionHistoryResponses,
    HistoryGetTransactionHistoryErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/History',
    ...options,
  });

/**
 * Retrieve an order from history by id
 *
 * Returns a list of orders customer has made. To do a detailed search of a specific order
 * save OrderId and ServiceJourneyRef and send into details/{orderId}/{serviceJourneyRef}.
 * To map passengers from details/ api, save the OrderLineId as it represents each leg trip for a specific passenger.
 */
export const historyGetTransactionHistoryOrder = <ThrowOnError extends boolean = false>(
  options: Options<HistoryGetTransactionHistoryOrderData, ThrowOnError>,
): RequestResult<HistoryGetTransactionHistoryOrderResponses, HistoryGetTransactionHistoryOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<
    HistoryGetTransactionHistoryOrderResponses,
    HistoryGetTransactionHistoryOrderErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/History/historyOrder/{orderId}',
    ...options,
  });

export const historyGetDetails = <ThrowOnError extends boolean = false>(
  options: Options<HistoryGetDetailsData, ThrowOnError>,
): RequestResult<HistoryGetDetailsResponses, HistoryGetDetailsErrors, ThrowOnError> =>
  (options.client ?? client).get<HistoryGetDetailsResponses, HistoryGetDetailsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/History/details/{orderId}',
    ...options,
  });

/**
 * Get all journeys with filter
 */
export const journeyGet = <ThrowOnError extends boolean = false>(
  options?: Options<JourneyGetData, ThrowOnError>,
): RequestResult<JourneyGetResponses, JourneyGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<JourneyGetResponses, JourneyGetErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey',
    ...options,
  });

/**
 * Gets journey plan without any offers from OTP2.
 *
 * API returns the journey plan for a certain date time without any offers or products.
 */
export const journeyGetJourneyPlan = <ThrowOnError extends boolean = false>(
  options?: Options<JourneyGetJourneyPlanData, ThrowOnError>,
): RequestResult<JourneyGetJourneyPlanResponses, JourneyGetJourneyPlanErrors, ThrowOnError> =>
  (options?.client ?? client).get<JourneyGetJourneyPlanResponses, JourneyGetJourneyPlanErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/journeyplan',
    ...options,
  });

/**
 * Get earlier departure alternatives for journey leg
 */
export const journeyGetEarlierDeparturesForLeg = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetEarlierDeparturesForLegData, ThrowOnError>,
): RequestResult<JourneyGetEarlierDeparturesForLegResponses, JourneyGetEarlierDeparturesForLegErrors, ThrowOnError> =>
  (options.client ?? client).get<
    JourneyGetEarlierDeparturesForLegResponses,
    JourneyGetEarlierDeparturesForLegErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/{tripPatternId}/legs/{legIndex}/earlier',
    ...options,
  });

/**
 * Get later departure alternatives for journey leg
 */
export const journeyGetLaterDeparturesForLeg = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetLaterDeparturesForLegData, ThrowOnError>,
): RequestResult<JourneyGetLaterDeparturesForLegResponses, JourneyGetLaterDeparturesForLegErrors, ThrowOnError> =>
  (options.client ?? client).get<
    JourneyGetLaterDeparturesForLegResponses,
    JourneyGetLaterDeparturesForLegErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/{tripPatternId}/legs/{legIndex}/later',
    ...options,
  });

/**
 * Replace part of journey
 */
export const journeyReplaceLegInJourney = <ThrowOnError extends boolean = false>(
  options: Options<JourneyReplaceLegInJourneyData, ThrowOnError>,
): RequestResult<JourneyReplaceLegInJourneyResponses, JourneyReplaceLegInJourneyErrors, ThrowOnError> =>
  (options.client ?? client).post<JourneyReplaceLegInJourneyResponses, JourneyReplaceLegInJourneyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/{tripPatternId}/legs/{legIndex}/replace',
    ...options,
  });

/**
 * Get earlier departure alternatives
 */
export const journeyGetEarlierDepartures = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetEarlierDeparturesData, ThrowOnError>,
): RequestResult<JourneyGetEarlierDeparturesResponses, JourneyGetEarlierDeparturesErrors, ThrowOnError> =>
  (options.client ?? client).post<
    JourneyGetEarlierDeparturesResponses,
    JourneyGetEarlierDeparturesErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/legs/{legIndex}/earlier',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Get later departure alternatives
 */
export const journeyGetLaterDepartures = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetLaterDeparturesData, ThrowOnError>,
): RequestResult<JourneyGetLaterDeparturesResponses, JourneyGetLaterDeparturesErrors, ThrowOnError> =>
  (options.client ?? client).post<JourneyGetLaterDeparturesResponses, JourneyGetLaterDeparturesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/legs/{legIndex}/later',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Replace part of journey
 */
export const journeyReplaceLeg = <ThrowOnError extends boolean = false>(
  options: Options<JourneyReplaceLegData, ThrowOnError>,
): RequestResult<JourneyReplaceLegResponses, JourneyReplaceLegErrors, ThrowOnError> =>
  (options.client ?? client).post<JourneyReplaceLegResponses, JourneyReplaceLegErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Journey/legs/{legIndex}/replace',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const locationGetGoAheadLocations = <ThrowOnError extends boolean = false>(
  options?: Options<LocationGetGoAheadLocationsData, ThrowOnError>,
): RequestResult<LocationGetGoAheadLocationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LocationGetGoAheadLocationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Location/locations',
    ...options,
  });

/**
 * Get period ticket offers
 */
export const offerGetPeriodTicketOffers = <ThrowOnError extends boolean = false>(
  options: Options<OfferGetPeriodTicketOffersData, ThrowOnError>,
): RequestResult<OfferGetPeriodTicketOffersResponses, OfferGetPeriodTicketOffersErrors, ThrowOnError> =>
  (options.client ?? client).post<OfferGetPeriodTicketOffersResponses, OfferGetPeriodTicketOffersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Offer/period-ticket',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const offerGetTripPatternInfo = <ThrowOnError extends boolean = false>(
  options?: Options<OfferGetTripPatternInfoData, ThrowOnError>,
): RequestResult<OfferGetTripPatternInfoResponses, OfferGetTripPatternInfoErrors, ThrowOnError> =>
  (options?.client ?? client).post<OfferGetTripPatternInfoResponses, OfferGetTripPatternInfoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Offer/TripPatternInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const ticketRefundTicket = <ThrowOnError extends boolean = false>(
  options: Options<TicketRefundTicketData, ThrowOnError>,
): RequestResult<TicketRefundTicketResponses, TicketRefundTicketErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketRefundTicketResponses, TicketRefundTicketErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Ticket/refund/{orderId}',
    ...options,
  });

/**
 * Reserve an offer.
 *
 * clientType is an enum on back-end. Values are
 * Web (default)
 * Android
 * iOS
 * App
 */
export const ticketReserve = <ThrowOnError extends boolean = false>(
  options?: Options<TicketReserveData, ThrowOnError>,
): RequestResult<TicketReserveResponses, TicketReserveErrors, ThrowOnError> =>
  (options?.client ?? client).post<TicketReserveResponses, TicketReserveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Ticket/reserve',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Review the specified order
 *
 * Returns all information about the order.
 */
export const ticketReviewOrder = <ThrowOnError extends boolean = false>(
  options: Options<TicketReviewOrderData, ThrowOnError>,
): RequestResult<TicketReviewOrderResponses, TicketReviewOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<TicketReviewOrderResponses, TicketReviewOrderErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Ticket/review/{orderId}',
    ...options,
  });

/**
 * E.g. call to https://app-ga-backend.azurewebsites.net/rest/v2/Ticket/sms/FN2Z9H4L
 * in app insigts requests (shown as name "POST Ticket/SendSms [orderId/version]").
 */
export const ticketSendSms = <ThrowOnError extends boolean = false>(
  options: Options<TicketSendSmsData, ThrowOnError>,
): RequestResult<TicketSendSmsResponses, TicketSendSmsErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketSendSmsResponses, TicketSendSmsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/v2/Ticket/sms/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });
